import React from 'react';

/*
 * Two-tone centered section title with the short cyan underline bar (SPEC §4).
 * Renders: <white> <accent> e.g. Our **Services**.
 * Pass accentFirst to flip (e.g. **Structural** Engineering).
 */
export default function SectionTitle({
  white,
  accent,
  accentFirst = false,
  underline = true,
  as: Tag = 'h2',
  align = 'center',
  className = '',
}) {
  return (
    <div className={`section-title-wrap${className ? ` ${className}` : ''}`} style={{ textAlign: align }}>
      <Tag className="section-title" style={{ textAlign: align }}>
        {accentFirst ? (
          <>
            <span className="accent">{accent}</span>
            {white ? <> {white}</> : null}
          </>
        ) : (
          <>
            {white}
            {accent ? <> <span className="accent">{accent}</span></> : null}
          </>
        )}
      </Tag>
      {underline && (
        <div
          className="title-underline"
          style={align === 'left' ? { marginLeft: 0 } : undefined}
          aria-hidden="true"
        />
      )}
    </div>
  );
}
